<template>
	<v-card class="pa-2">
		<h2>
			{{ title }}
		</h2>
		<h3
			v-if="!getTotal"
			class="text-center no-data-available-h3"
		>
			No Data Available
		</h3>
		<Doughnut
			:chart-options="chartOptions"
			:chart-data="chartData"
			:chart-id="chartId"
			:dataset-id-key="datasetIdKey"
			:plugins="plugins"
			:css-classes="cssClasses"
			:styles="styles"
			:width="width"
			:height="height"
		/>
		<template v-if="getTotal >= 1">
			<h3 class="mt-2">
				Total:
				<span class="font-weight-light">
					{{ getTotal }}
				</span>
			</h3>
			<hr>
		</template>
		<div
			v-show="getTotal >= 1"
			:id="containerId"
		/>
	</v-card>
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy'

import {
	Chart as ChartJS,
	Title,
	Tooltip,
	Legend,
	ArcElement,
	CategoryScale
} from 'chart.js'
import htmlLegendPluginMixin from '../mixins/html-legend-plugin.js'

export default {
	name: 'doughnut-chart',
	components: {
		Doughnut
	},
	mixins: [htmlLegendPluginMixin],
	props: {
		chartId: {
			type: String,
			default: 'doughnut-chart'
		},
		datasetIdKey: {
			type: String,
			default: 'label'
		},
		width: {
			type: Number,
			default: 400
		},
		height: {
			type: Number,
			default: 300
		},
		cssClasses: {
			default: '',
			type: String
		},
		styles: {
			type: Object,
			default: () => {}
		},
		plugins: {
			type: Array,
			default: () => []
		},
		chartData: {
			type: Object
		},
		chartOptions: {
			type: Object
		},
		containerId: {
			type: String
		},
		title: {
			type: String
		}
	},
	computed: {
		getTotal () {
			const data = this.chartData.datasets[0].data
			return data.reduce((acc, val) => acc + val, 0)
		}
	},
	created () {
		// Set global font defaults for Chart.js
		ChartJS.defaults.font.family = 'Inter, sans-serif'
		ChartJS.defaults.font.size = 12
		ChartJS.defaults.font.weight = '400'

		ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, this.htmlLegendPlugin(this.containerId))
	},
	mounted () {
		ChartJS.unregister(this.htmlLegendPlugin(this.containerId))
	}
}
</script>

<style scoped>
h2 {
  text-align: center;
  transform: translateY(149px);
  line-height: 0;
  font-size: 1.5rem;
}

.no-data-available-h3 {
	transform: translateY(170px)
}

h3 {
	font-size: 1.2rem;
}

@media only screen and (max-width: 1400px) {
  h2 {
    font-size: 1.2rem
  }
}
@media only screen and (max-width: 1200px) {
  h2 {
    font-size: 1rem
  }
}

</style>
